import { render, staticRenderFns } from "./MenuCardNotifications.vue?vue&type=template&id=094f9881&scoped=true"
import script from "./MenuCardNotifications.vue?vue&type=script&lang=js"
export * from "./MenuCardNotifications.vue?vue&type=script&lang=js"
import style0 from "./MenuCardNotifications.vue?vue&type=style&index=0&id=094f9881&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094f9881",
  null
  
)

export default component.exports